import React from 'react'
import PropTypes from 'prop-types'
import BaseFooter from 'components/Shared/BaseFooter/BaseFooter'

const OnboardingFooter = (props) => {
  const { sidebarDataLoaded } = props

  return (
    <BaseFooter
      data-test-id="base-footer"
      sidebarDataLoaded={sidebarDataLoaded}
      showPricing={true}
      showTel={true}
      showMorningstarLogo={true} />
  )
}

OnboardingFooter.propTypes = {
  sidebarDataLoaded: PropTypes.bool.isRequired,
}

export default OnboardingFooter



// WEBPACK FOOTER //
// ./src/components/Onboarding/OnboardingFooter/OnboardingFooter.jsx